import React from "react";
import CRMInputLabelAndErrorWrapComponent from "../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import { TCRMFormInputWithoutCodec } from "./CRMFormInputTypes";
import CRMTextAreaComponent from "../CRMTextAreaComponent/CRMTextAreaComponent";

export const CRMTextAreaFormInput: TCRMFormInputWithoutCodec<string> = (props) => 
<CRMInputLabelAndErrorWrapComponent label={props.label}>
    <CRMTextAreaComponent
        value={props.model}
        onChange={(value) => props.onChange(value)}
        displayError={props.displayError}
        disabled={props.disabled}
    />
</CRMInputLabelAndErrorWrapComponent>